// src/utils/firebase/exertionReports.js
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { firebaseApp } from "../../firebase/firebaseApp";

const ordersDocRef = (uid, activityId) =>
  doc(
    getFirestore(firebaseApp),
    "breatheultra_orders",
    uid,
    "exertion_reports",
    activityId
  );

export async function getExertionReportOrder(uid, activityId) {
  if (!uid || !activityId) return null;
  const snap = await getDoc(ordersDocRef(uid, activityId));
  return snap.exists() ? snap.data() : null;
}

export async function createExertionReportOrder(params) {
  const {
    uid,
    activityId,
    price, // pence, e.g. 2900
    currency, // e.g. "GBP"
    activityDateMs, // optional
    resultRef, // optional
    note, // optional
  } = params || {};

  if (!uid) throw new Error("uid is required");
  if (!activityId) throw new Error("activityId is required");
  if (typeof price !== "number") throw new Error("price (number) is required");
  if (!currency) throw new Error("currency is required");

  const payload = {
    status: "requested",
    price,
    currency,
    activityId,
    activityDateMs: activityDateMs ?? null,
    resultRef: resultRef ?? null,
    note: note ?? null,
    createdAt: serverTimestamp(),
    version: 1,
  };

  await setDoc(ordersDocRef(uid, activityId), payload, { merge: false });
  return payload;
}
